import axios from 'axios'

const API = process.env.API_URL

const config = {
  headers: {
    'Accept': 'application/ld+json',
    'Cache-Control': 'no-transform'
  }
}

const lists = {
  fetchOne (id) {
    return axios.get(`${API}/Templates/${id}`, {
      config
    })
  },

  create (list) {
    return axios.post(`${API}/Lists`, list, {
      config
    })
  },

  fetchStats (id) {
    return axios.get(`${API}/Templates/${id}/stats`, {
      config
    })
  },

  fetchSettings (id) {
    return axios.get(`${API}/Templates/${id}/settings`, {
      config
    })
  },

  fetchTemplate (id) {
    return axios.get(`${API}/Lists/${id}/template`, {
      config
    })
  },

  fetchUserOne (id) {
    return axios.get(`${API}/Lists/${id}`, {
      config
    })
  },

  count (id) {
    return axios.get(`${API}/Lists/${id}/template/lists/count`, {
      config
    })
  }
}

export { lists }



// WEBPACK FOOTER //
// ./src/api/index.js